import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../assets/styles/Blog.css';

interface TagsListProps {
  tags: string[];
  selectedTag?: string;
  onTagSelect: (tag: string) => void;
}

const TagsList: React.FC<TagsListProps> = ({ tags, selectedTag, onTagSelect }) => {
  const [expanded, setExpanded] = useState(false);
  
  // Initial number of tags to show
  const initialTagsCount = 10;
  
  // Determine if we need the "show more" functionality
  const needsExpansion = tags.length > initialTagsCount;
  
  // Get tags to display based on expansion state
  const displayedTags = expanded ? tags : tags.slice(0, initialTagsCount);
  
  return (
    <div className="blog-tags-container">
      <div className="blog-tags-header">
        <h3 className="blog-tags-title">Filter by topic:</h3>
        {needsExpansion && (
          <button 
            className="blog-tags-toggle" 
            onClick={() => setExpanded(!expanded)}
            aria-expanded={expanded}
          >
            {expanded ? 'Show fewer tags' : `Show ${tags.length - initialTagsCount} more tags`}
          </button>
        )}
      </div>
      <div className="blog-tags-filter">
        {displayedTags.map(tag => (
          <button
            key={tag}
            className={`blog-tag ${tag === selectedTag ? 'active' : ''}`}
            onClick={() => onTagSelect(tag)}
          >
            {tag}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TagsList; 